import { Component, OnInit, Renderer } from '@angular/core';
import { CommonService } from '../service/common.service';
import { YoyakuService } from "../service/yoyaku.service";
import { ShareService } from '../service/share.service';
import { UsersService } from '../service/users.service';
import { MailService } from '../service/mail.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

import { AnswerStatus, Mode } from '../app.constant';

declare let $;
declare let jsPDF;
declare let html2canvas;

@Component({
  selector: 'app-a2112-confirm-preview',
  templateUrl: './a2112-confirm-preview.component.html',
  styleUrls: ['./a2112-confirm-preview.component.css']
})
export class A2112ConfirmPreviewComponent implements OnInit {


  constructor(
    private commonService: CommonService,
    private usersService: UsersService,
    private shareService: ShareService,
    private mailService: MailService,
    private renderer: Renderer,    
    private router: Router,
    private yoyakuService: YoyakuService,
    private location: Location,
  ) { }

  yoyakuInfo: any;
  answerUserInfo: any;
  questionList: any;
  resultList: any;
  userInfo: any;
  mode: number;
  MODE = Mode;

  ngOnInit() {
    //component読み込みのため、スクロール位置を固定で一番上に
    window.scrollTo(0, 0);

    this.yoyakuInfo = this.shareService.getCategoryInfoShare();
    this.resultList = this.shareService.getResultListShare();
    this.userInfo = this.usersService.userinfo;
    this.answerUserInfo = this.shareService.getAnswerUserInfo();
    this.mode = this.shareService.getModeShare();

    if (this.resultList == null || this.resultList.length == 0
       || this.yoyakuInfo == null) {
      this.commonService.modalOpens(90001, modalresult => {
      });
      this.router.navigate(["/admin"]);
    }
  }

  save() {
    this.commonService.modalOpens(50013, modalresult => {
      if (modalresult == "OK") {

        //↓いらないかもしれない
        let resultList = JSON.parse(JSON.stringify(this.resultList));
        //予約ID
        //予約時のポイント
        this.yoyakuService.saveYoyaku(resultList)
          .subscribe((res: Response) => {
          if (res["fuel_status"] == "OK") {
            this.commonService.modalOpens(10008, modalresult => {
              if (modalresult == "OK") {
                let mode = res["fuel_results"]["mode"];
                resultList.mode = mode;
                this.mailService.send(resultList)
                .subscribe((res: Response) => {
                  if (res["fuel_status"] == "OK") {
                  }
                });
                this.shareService.refleshAll();
                this.router.navigate(["/person/" + this.yoyakuInfo.t_event_id]);
              }
            });
          }else if (res["fuel_status"] == "NG") {
            if (res["fuel_message"] == "NotReserved"){
              this.commonService.modalOpens(11012, modalresult => {
                if (modalresult == "OK") {
                  this.location.back();
                }
            });
            } else {
              this.commonService.modalOpens(res["fuel_message"], modalresult => {
                if (modalresult == "OK") {
                  this.location.back();
                }
              });
            }
          }else{
            this.commonService.modalOpens(11003, modalresult => {
              if (modalresult == "OK") {
                this.location.back();
              }
              });
          }
        }, error => {
          this.commonService.modalOpens(error, modalresult => {
            if (modalresult == "OK") {
              this.location.back();
            }
           });
        });
      } else {

      }
    });

  }

  goBack(): void {
    this.location.back();
  }

  check38(): boolean{
    if("inputParam" in this.resultList){
      let temp = "";
      for(let i=0; this.resultList.inputParam.length>i; i++){
        if(this.resultList.inputParam[i].m_question_kbn_id!="4"&&this.resultList.inputParam[i].m_question_kbn_id!="5"){
          if(this.resultList.inputParam[i].m_question_param == null || this.resultList.inputParam[i].m_question_param == ""){
            return true
          }else if(this.resultList.inputParam[i].m_question_kbn_id=="3"){
            temp = this.resultList.inputParam[i].m_question_param;
          }
        }else if(this.resultList.inputParam[i].m_question_kbn_id=="4"){
          if(temp=="2"||temp=="3"){
            if(this.resultList.inputParam[i].m_question_param == null || this.resultList.inputParam[i].m_question_param == ""){
              return true
            }
          }
        }
      }
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/a2112-yoyaku-preview/a2112-confirm-preview.component.ts